import { CIcon } from '~/icons/types'

export const ciHome: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'm22.3 11.502-9-9c-.7-.7-1.9-.7-2.7 0L4 9.202l-2.2 2.2c-.3.3-.3.8 0 1.1.3.3.8.3 1.1 0l1-1v8.3c0 1 .8 1.9 1.9 1.9h12.8c1 0 1.9-.8 1.9-1.9v-8.3l1 1c.3.3.8.3 1.1 0 .3-.3 0-.7-.3-1Zm-8.8 8.7h-3v-4.1c0-.2.2-.4.4-.4h2.2c.2 0 .4.2.4.4v4.1Zm5.3-.3c0 .2-.2.4-.4.4H15v-4.1c0-1-.8-1.9-1.9-1.9h-2.2c-1 0-1.9.8-1.9 1.9v4.1H5.6c-.2 0-.4-.2-.4-.4v-9.8l6.5-6.5c.1-.1.4-.1.5 0l6.5 6.5v9.8h.1Z',
      fill: 'currentColor'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'home',
  type: 'light'
}
